import { render, staticRenderFns } from "./textList.vue?vue&type=template&id=1abcf648&scoped=true"
import script from "./textList.vue?vue&type=script&lang=js"
export * from "./textList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abcf648",
  null
  
)

export default component.exports